import { styled, TableCell } from "@mui/material";

export const PropertyNameCell = styled(TableCell)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  padding: `0 ${theme.spacing(2)} 0 0`,
  minWidth: "6em",
}));
